import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import StarIcon from "@material-ui/icons/Star";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import GroupIcon from "@material-ui/icons/Group";

export const FeaturesSection = () => {
  const features = [
    {
      icon: <EventAvailableIcon style={{ fontSize: 48, color: "#EF3E6D" }} />,
      title: "Massive Time Savings",
      desc: "We handle all the admin, research, and submissions so you can focus on serving customers.",
    },
    {
      icon: <StarIcon style={{ fontSize: 48, color: "#EF3E6D" }} />,
      title: "Smarter Bookings",
      desc: "Data-driven decisions from 30+ years of event expertise to boost success.",
    },
    {
      icon: <FlashOnIcon style={{ fontSize: 48, color: "#EF3E6D" }} />,
      title: "Long-Term Strategy",
      desc: "Work with us to grow sustainably and develop a long-term event plan.",
    },
    {
      icon: <GroupIcon style={{ fontSize: 48, color: "#EF3E6D" }} />,
      title: "Custom Sales Projections",
      desc: "Compare event fees, projected revenue, and labor to make smart decisions.",
    },
  ];

  return (
    <section className="py-5 bg-white">
      <Container>
        <h2 className="text-center fw-bold mb-4" style={{ color: "#2959A5" }}>
          Why Vendors Love This Service
        </h2>
        <p className="text-center text-muted mb-5" style={{ maxWidth: "700px", margin: "0 auto" }}>
          Our scheduling service isn't just about filling your calendar — it's designed to save you time, increase your revenue, and help your business grow strategically.
        </p>
        <Row className="g-4">
          {features.map((feature, idx) => (
            <Col key={idx} xs={12} md={6} lg={3}>
              <div
                className="bg-[#F3F1EF] text-center p-4 rounded-4 shadow-sm h-100 d-flex flex-column justify-content-center align-items-center transition"
                style={{ transition: "transform 0.3s" }}
              >
                {feature.icon}
                <h4 className="fw-bold mt-3" style={{ color: "#2959A5" }}>{feature.title}</h4>
                <p className="text-muted">{feature.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};
